export default values => {
  return {
    options: values ?? []
  };
};
